export default {
  header : [
    {
      title : '+ Projects',
      children : [
        {
          title: '2017 Inaugural Season',
          to: '/2017-inaugural-season'
        },
        {
          title: '2018 Chamber Series',
          to: '/2018-chamber-series'
        }
      ]
    },
    {
      title : 'Press & Media',
      to : '/press-media/',
    },
    {
      title : 'About',
      to : '/about/',
    },
    {
      isLanguageToggle : true,
      title : '中文',

    },
  ],
  'home_page' : {
    'backgrounds' : [
      {
        src: "/img/home/2017-inaugural-season.jpg",
        href: "/2017-inaugural-season",
        name: "2017 INAUGURAL SEASON",
      },
      {
        src: "/img/home/2018-chamber-series.jpg",
        href: "/2018-chamber-series",
        name: "2018 CHAMBER SERIES",
      }
    ]
  },
  'about_page' : {

    overview : {
      title : 'About NYO-China',
      imgSrc : '/img/about/entering_carnegie.jpg',
      description : [
        {
          'text':'The National Youth Orchestra of China (NYO-China) is a full symphony youth orchestra composed of approximately 100 Chinese musicians aged 14 to 21 years old. Students gather for two and a half weeks in the United States to partake in a training residency before premiering at Carnegie Hall and participating in a concert tour abroad. In doing so, China’s most promising young musicians are able to serve as ambassadors for both their country and their generation on a global stage.',
          'containsHTML': 'false',
        },
        {
          'text':'NYO-China was established in 2016 with its first residency and concert tour taking place in Summer 2017, beginning with a debut concert officially presented by Carnegie Hall; the sold-out premiere, which featured renowned pianist Yuja Wang, received critical acclaim from numerous publications including <em> <a href="https://www.nytimes.com/2017/07/23/arts/music/review-us-youth-orchestra-inspires-a-chinese-counterpart.html" target="_blank">The New York Times</a></em>. Inspired by Carnegie Hall’s National Youth Orchestra of the United States of America (NYO-USA), NYO-China was created in part to complement its American analogue, which was identified as a cultural pillar at the the US-China High Level Consultation on People-to-People Exchange (CPE) that was co-chaired by Vice Premier Liu Yandong and Secretary of State John Kerry.',
          'containsHTML': 'true',
        },
        {
          'text':'The entire program is provided at no costs to students; all expenses, including tuition, travel, and housing, are covered to ensure that no talented musician is ever turned away for lack of funds. ',
          'containsHTML': 'false',
        }
      ]
    },

    'endorsements' : {
      'title' : 'Endorsements',
      'endorsement_list' : [
        {
          'imgSrc' : '/img/about/endorsers/robert-blocker.jpg',
          'name' : 'Robert Blocker',
          'title' : 'The Henry and Lucy Moses Dean of Music at Yale',
          'text' : '“These young musicians are going to be playing in the great concert halls of the world, making music with some of the most celebrated artists across the globe. NYO-China will be a transformative experience for them.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/clive-gillinson.jpg',
          'name' : 'Sir Clive Gillinson',
          'title' : 'Executive and Artistic Director of Carnegie Hall',
          'text' : '“The growth of music in China is astounding. It is going to be a central part of what defines music in the 21st century world. NYO-China will be a beacon of excellence and something everyone aspires to.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/gary-graffman.jpg',
          'name' : 'Gary Graffman',
          'title' : 'Former President of the Curtis Institute of Music',
          'text' : '“When I listen to the extraordinary students at Curtis, I hear the bright future of classical music. Now, NYO-China is helping their Chinese counterparts contribute to that same narrative but for audiences everywhere.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/yue-sai-kan.jpg',
          'name' : 'Yue-Sai Kan',
          'title' : 'Emmy Award-Winning Television Host & Entrepreneur',
          'text' : '“All performance, from musical concerts to beauty pageants, inspires people to strive for excellence in their field. The young musicians of NYO-China will be motivated by the opportunity to perform for the world.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/gary-locke.jpg',
          'name' : 'Gary Locke',
          'title' : 'Former US Ambassador to China',
          'text' : '“NYO-China will bring people together through the common language of music. It will help break down barriers that have long existed between countries and promote an understanding of each other’s culture.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/ron-losby.jpg',
          'name' : 'Ron Losby',
          'title' : 'CEO of Steinway & Sons',
          'text' : '“NYO-China gives students an opportunity to perform for large audiences what they have practiced for so long. There\'s nothing quite like a concert experience, and it will live within them for many years to come.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/chien-chung-pei.jpg',
          'name' : 'Chien Chung Pei',
          'title' : 'Chairman of the Board at the China Institute',
          'text' : '“Music is something that gets into your blood, and something that you can’t get rid of! For all the young artists of China, this orchestra is an excellent opportunity for them to expand their whole idea of what music is all about.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/tan-dun.jpg',
          'name' : 'Tan Dun',
          'title' : 'Academy Award-Winning Composer',
          'text' : '“Writing for and performing with a youth orchestra has been one of the best ways to train myself as a composer and conductor. Young musicians always inspire me. Learning from them is the reason that I\'m here.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/ye-xiaogang.jpg',
          'name' : 'Ye Xiaogang',
          'title' : 'President of the Chinese Musicians Association',
          'text' : '“Through this program, China\'s young artists will use their astounding musical ability to take on the world! This will be a historic orchestra and a cultural phenomenon to share with both China and the United States.”',
        },
        {
          'imgSrc' : '/img/about/endorsers/zhang-qiyue.jpg',
          'name' : 'Zhang Qiyue',
          'title' : 'Ambassador & Consul General of China in New York',
          'text' : '“NYO-China is a unique platform to present China\'s most promising musical talents to the American public. It will prepare these young musicians as future leaders in art and culture, in China and throughout the world.”',
        }
      ]
    },
    'location' : {
      'title' : 'Our Office',
      'address' : {
        'line1' : '810 Seventh Avenue, Suite 2000',
        'line2' : 'New York, New York 10019',
        'line3' : 'United States',
      },
      'coords' : {
        'lat' : 40.762873,
        'lng' : -73.982590,
      }
    },

    'contact' : {
      'title' : 'Contact Us',
      'instruction' : 'For your convenience, please feel free to use the form.',
      'methods' : [
        {
          'text':'General Inquiries',
          'isLink': false,
        },
        {
          'text':'english@nyochina.org',
          'isLink': true,
        },
        {
          'text':'chinese@nyochina.org',
          'isLink': true,
        },
        {
          'text':'Vincent Accettola',
          'isLink': false,
        },
        {
          'text':'Managing Director',
          'isLink': false,
        },
        {
          'text':'vincent.accettola@nyochina.org',
          'isLink': true,
        },
        {
          'text':'Nicholas Brown',
          'isLink': false,
        },
        {
          'text':'Director of Project Development',
          'isLink': false,
        },
        {
          'text':'nicholas.brown@nyochina.org',
          'isLink': true,
        },
        {
          'text':'Peggie Zhong',
          'isLink': false,
        },
        {
          'text':'Communications Coordinator',
          'isLink': false,
        },
        {
          'text':'peggie.zhong@nyochina.org',
          'isLink': true,
        },
      ],
      'form' : {
        'submit' : 'SUBMIT',
        'name' : 'Name',
        'firstName' : 'First Name',
        'lastName' : 'Last Name',
        'email' : 'Email Address',
        'subject' : 'Subject',
        'message' : 'Message',
        'submissionMessage' : 'Thank you!',
        'invalidFormMsgTop' : 'Your form has encountered a problem. Please scroll down to review.',
        'invalidFormMsgBottom' : 'Your form has encountered a problem. Please scroll up to review.',
        'missingFirstAndLastNameMsg' : 'Name is required.',
        'missingFirstNameMsg' : 'Name is missing required subfields: First',
        'missingLastNameMsg' : 'Name is missing required subfields: Last',
        'missingEmailMsg' : 'Email Address is required',
        'invalidEmailMsg' : 'Email Address is not valid. Email addresses should follow the format user@domain.com.',
        'missingSubjectMsg' : 'Subject is required.',
        'missingMessageMsg' : 'Message is required.',
      }
    }

  },
  'inaugural_season_page' : {
    overview : {
      title : '2017 Inaugural Season',
      imgSrc : '/img/inaugural_season/carnegie_concerto.jpg',
      description : [
        {
          'text':'The National Youth Orchestra of China (NYO-China) launched in 2017 with the goal of providing exceptional young Chinese musicians access to world-class instruction, extraordinary performance opportunities, and a platform upon which can might represent their country, and their generation – to the world. From a pool of over one thousand applicants, 105 remarkable musicians, aged 14 to 21 years old and representing all regions of China, were selected to join the inaugural ensemble. To ensure that no excellent musician was turned away for lack of funds, the entire program – including tuition, travel, room, and board – was provided at absolutely no cost to students.',
          'containsHTML': 'false',
        },
        {
          'text':'In Summer 2017, these young instrumentalists gathered in the United States for a rigorous two-week training residency with world-renowned teaching artists before embarking on a concert tour of the United States and China, beginning with a sold-out premiere presented by Carnegie Hall.',
          'containsHTML': 'false',
        },
      ]
    },
    overview_blocks : [
      {
        title : 'Training Residency',
        imgSrc : '/img/inaugural_season/training_residency.jpg',
        description : [
          {
            'text':'NYO-China held its training residency at East Stroudsburg University of Pennsylvania. There, members rehearsed with NYO-China’s suite of distinguished Teaching Artists, adhering to an intensive schedule of full orchestra rehearsals, sectional rehearsals, master classes, and private lessons. Members also had the opportunity to attend workshops hosted by guest speakers such as Juilliard’s Alexander Technique Instructor Lori Schiff and improvisation expert Eugene Friesen, as well as recreational chamber music activities coordinated by NYO-China’s staff. All told, the two-week residency helped prepare members for not just their forthcoming concert tour, but also their future lives as professional musicians.',
            'containsHTML': 'false',
          }
        ]
      },
      {
        title : 'Joint Rehearsal with NYO-USA',
        imgSrc : '/img/inaugural_season/joint_rehearsal.jpg',
        description : [
          {
            'text':'On July 16, the members of NYO-China joined their American counterparts from the National Youth Orchestra of the United States of America (NYO-USA) for an afternoon of cultural exchange and music-making at the State University of New York at Purchase. Students from both orchestras were able to meet, connect, and partake in a joint rehearsal led by Maestro Ludovic Morlot (Music Director of the Seattle Symphony and NYO-China’s 2017 Guest Conductor), James Ross (NYO-USA’s Orchestra Director), and Jindong Cai (NYO-China’s Artistic Director). Later that week, the two groups attended each other’s Carnegie Hall debuts, allowing members of each ensemble to see the results of the other’s hard work.',
            'containsHTML': 'false',
          }
        ]
      },
      {
        title : 'Debut at Carnegie Hall',
        imgSrc : '/img/inaugural_season/carnegie_debut.jpg',
        description : [
          {
            'text':'NYO-China premiered at Carnegie Hall on the evening of July 22, 2017. Under the baton of Maestro Morlot and featuring Yuja Wang on piano, the orchestra presented a program that included Zhou Long\'s The Rhyme of Taigu, Tchaikovsky\'s Piano Concerto No. 1, and Dvorák\'s Symphony No. 9, “From the New World” (popularly known as the New World Symphony); Yuja performed Variations on a Theme from Carmen by Bizet & Horowitz as a solo encore. The 2804-seat Stern Auditorium was fully sold out, and the performance was broadcast live to audiences worldwide via Medici.tv. The concert was also a critical success, with The New York Times remarking that <em> <a href="https://www.nytimes.com/2017/07/23/arts/music/review-us-youth-orchestra-inspires-a-chinese-counterpart.html" target="_blank"> “if [the performance at Carnegie Hall] was a test run for this new venture, these Chinese musicians scored big." </a> </em>',
            'containsHTML': 'true',
          }
        ]
      },
      {
        title : 'Concert Tour of China',
        imgSrc : '/img/inaugural_season/concert_tour.jpg',
        description : [
          {
            'text':'NYO-China’s concert tour saw the orchestra visit premier venues throughout China, including the Beijing Concert Hall, the Shanghai Oriental Arts Center, and the Suzhou Grand Theater, performing for over 5000 of their native concertgoers. Joined by pianist Olga Kern, students brought the delights of their Carnegie Hall performance to audiences in each city, including many of their friends and family. The ensemble was honored to be introduced in each city by acclaimed composer Ye Xiaogang, who also arranged the orchestra\'s encore piece Thunder in a Drought. At the end of the week-long tour, the orchestra’s members returned to their home cities with a uniquely valuable set of experiences and a new network of musical friends and colleagues throughout China.',
            'containsHTML': 'false',
          }
        ]
      }
    ],
    featured_artists : {
      title : 'Featured Artists',
      artists : [
        {
          title : 'Ludovic Morlot',
          imgSrc : '/img/inaugural_season/ludovic_morlot.png',
          description : [
            {
              'text':'Ludovic Morlot is a bright star among a new generation of international conductors, serving as the principal conductor of the Seattle Symphony and a frequent guest conductor of the orchestras of Boston, Chicago, Los Angeles, and New York. As conductor of the Seattle Symphony, Morlot won the 2016 GRAMMY Award for “Best Classical Instrumental Solo” for conducting Augustin Hadelich in Dutilleux’s Violin Concerto. Prior to his tenure at the Seattle Symphony, Morlot served as the conductor-in-residence at the Orchestre National de Lyon (ONL) under David Robertson from 2002 to 2004 where he led ONL’s two youth orchestras. Beyond his duties at the Seattle Symphony, Morlot is also the chair of orchestral conducting studies at the University of Washington.',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : 'Yuja Wang',
          imgSrc : '/img/inaugural_season/yuja_wang.jpg',
          description : [
            {
              'text':'Yuja Wang is one of the world’s most sought-after pianists and was named Musical America’s 2017 Artist of the Year. Born in Beijing, Wang started playing the piano at the age of six and, only one year later, began studying at the Central Conservatory of Music in Beijing. In 2001, she was named a Steinway Artist and in 2002, she began studying with Gary Graffman at The Curtis Institute of Music in Philadelphia. Among her many other accolades are the 2006 Gilmore Young Artist Award, the 2009 Gramophone Classic FM’s Young Artist of the Year Award, and the 2011 ECHO KLASSIK Young Artist of the Year Award. Her impeccable technique, intelligent musical interpretations, and indelible star power make Yuja Wang an inspiration to young musicians around the world.',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : 'Olga Kern',
          imgSrc : '/img/inaugural_season/olga_kern.jpg',
          description : [
            {
              'text':'A Steinway Artist, Russian-American pianist Olga Kern is recognized as one of her generation\'s great pianists. The First Prize winner of the Rachmaninoff International Piano Competition at seventeen years old, Kern is a laureate of many international competitions. She kicked off her US career with her historic Gold Medal win at the Van Cliburn International Piano Competition in Fort Worth, Texas as the first woman to do so in more than thirty years. Kern\'s discography includes her GRAMMY-nominated recording of Rachmaninoff’s Corelli Variations and other transcriptions (2004), Brahms Variations (2007), and Chopin Piano Sonatas No. 2 and 3 (2010). In 2016, she served as Jury Chairman of the Seventh Van Cliburn International Amateur Piano Competition.',
              'containsHTML': 'false',
            }
          ]
        },
      ]
    },
    teaching_artists : {
      title : 'Teaching Artists',
      artists: [
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/jindong_cai.jpg',
          href : 'https://sso.stanford.edu/conductors/',
          'name' : 'Jindong Cai',
          'position' : 'Artistic Director',
          'affiliation' : 'Stanford University',
          'affiliate_position' : 'Professor of Performance'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/frank_huang.jpg',
          href : 'https://nyphil.org/about-us/artists/frank-huang',
          'name' : 'Frank Huang',
          'position' : 'Violin I',
          'affiliation' : 'New York Philharmonic',
          'affiliate_position' : 'Concertmaster'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/qing_li.jpg',
          href : 'https://www.bsomusic.org/musicians/musician/qing-li/',
          'name' : 'Qing Li',
          'position' : 'Violin II',
          'affiliation' : 'Baltimore Symphony',
          'affiliate_position' : 'Principal Second'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/jay_liu.jpg',
          href : 'https://www.sfsymphony.org/About-Us/Musicians-Conductors/Members-Of-Orchestra/Viola#artist-4197',
          'name' : 'Jay Liu',
          'position' : 'Viola',
          'affiliation' : 'San Francisco Symphony',
          'affiliate_position' : 'Associate Principal'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/qiang_tu.jpg',
          href : 'https://nyphil.org/about-us/artists/qiang-tu',
          'name' : 'Qiang Tu',
          'position' : 'Cello',
          'affiliation' : 'New York Philharmonic',
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/daxun_zhang.jpg',
          href : 'http://www.daxunzhang.com/',
          'name' : 'Daxun Zhang',
          'position' : 'Double Bass',
          'affiliation' : 'University of Texas',
          'affiliate_position' : 'Professor of Bass'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/sibei_weng.jpg',
          href : 'http://www.om-macau.org/en/artist/weng-sibei/',
          'name' : 'Sibei Weng',
          'position' : 'Flute',
          'affiliation' : 'Macau Orchestra',
          'affiliate_position' : 'Principal'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/yaoguang_zhai.jpg',
          href : 'http://www.yaoclarinet.com/',
          'name' : 'Yao Guang Zhai',
          'position' : 'Clarinet',
          'affiliation' : 'Baltimore Symphony',
          'affiliate_position' : 'Principal'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/liang_wang.jpg',
          href : 'https://nyphil.org/about-us/artists/liang-wang',
          'name' : 'Liang Wang',
          'position' : 'Oboe',
          'affiliation' : 'New York Philharmonic',
          'affiliate_position' : 'Principal'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/fei_xie.jpg',
          href : 'https://www.bsomusic.org/musicians/musician/fei-xie/',
          'name' : 'Fei Xie',
          'position' : 'Bassoon',
          'affiliation' : 'Baltimore Symphony',
          'affiliate_position' : 'Principal'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/xiaoming_han.jpg',
          href : 'http://www.drp-orchester.de/drp/orchester/musiker/musiker-han_xiao-ming100.html',
          'name' : 'Xiao Ming Han',
          'position' : 'Horn',
          'affiliation' : 'German Radio Philharmonic',
          'affiliate_position' : 'Principal'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/guang_chen.jpg',
          href : 'http://www.ccom-prep.org/ENG/contents/jxtd/CHENGUANG.html',
          'name' : 'Guang Chen',
          'position' : 'Trumpet',
          'affiliation' : 'Central Conservatory of Music',
          'affiliate_position' : 'Professor of Trumpet'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/wei_zhu.jpg',
          href : 'http://www.bremerphilharmoniker.de/index.php/Orchester/musiker.html',
          'name' : 'Wei Zhu',
          'position' : 'Trombone',
          'affiliation' : 'Bremer Philharmonic',
          'affiliate_position' : 'Principal'
        },
        {
          isClickable : false,
          imgSrc : '/img/inaugural_season/haiyu_wang.jpg',
          'name' : 'Haiyu Wang',
          'position' : 'Tuba',
          'affiliation' : 'Jacobs School of Music',
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/gert_mortensen.jpg',
          href : 'http://www.gertmortensen.com/',
          'name' : 'Gert Mortensen',
          'position' : 'Percussion',
          'affiliation' : 'The Royal Danish Academy of Music',
          'affiliate_position' : 'Professor'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/jieyin_wu.jpg',
          href : 'http://jieyinwu.com/',
          'name' : 'Jieyin Wu',
          'position' : 'Harp',
          'affiliation' : 'Concert Harpist',
        },
      ]
    },
    class_of_2017 : {
      title : 'Class of 2017',
      imgSrc : '/img/inaugural_season/class_of_2017.jpg',
      description : [
        {
          'text':'The 105 members of NYO-China’s inaugural class were selected through a competitive online audition process, chosen from over a thousand impressive young musicians who applied for admission. They hail from 23 different provinces / administrative divisions throughout China, live and study on three continents, and attend 38 conservatories and educational institutions around the world; among the postsecondary institutions represented include the Central Conservatory of Music, the China Conservatory of Music, the Shanghai Conservatory of Music, the Xinghai Conservatory of Music, Peking University, as well as overseas institutions such as the Juilliard School, the New England Conservatory of Music, and the Cleveland Institute of Music. Together, they represent some of the finest musical talent of their generation.',
          'containsHTML': 'false',
        },
      ]
    },
    link_to_website : {
      href : "https://2017.nyochina.org",
      text : 'SEE MEMBERS OF THE CLASS OF 2017 ON NYO-CHINA\'S ARCHIVED WEBSITE'
    },
  },
  chamber_series_page : {
    overview : {
      title : '2018 Chamber Series',
      imgSrc : '/img/chamber_series/yale_performance.jpg',
      description : [
        {
          'text':'The National Youth Orchestra of China will return in 2018 to present the NYO-China Chamber Series, a training residency and concert tour centered around the craft and performance of chamber music. For two weeks in July, between ten to fifteen musicians aged 14 to 21 (or up to 22 for NYO-China alumni) will gather at the central Conservatory of Music in Beijing in China to rehearse a selection of great works in the chamber music repertoire under the direction of a small faculty of teaching artists. Students and mentors will then join each other onstage to present their prepared works through a series of performances across China.',
          'containsHTML': 'false',
        },
        {
          'text':'The NYO-China Chamber Series is meant to provide its members with an especially focused and intimate musical experience. During the residency, students will benefit from both extended private instruction and increased rehearsal time spent in dialogue with their peers and teachers. Thereafter, the concert tour will provide numerous and varied opportunities for meaningful engagement with their listeners. In combination, these commitments will emphasize the necessity of open, honest relationships in music making, as well as the power of the connections that result from it.',
          'containsHTML': 'false',
        },
        {
          'text':'Like all NYO-China ventures, the entire program - tuition, room, board, and travel within China - will be absolutely free for students so that no exceptional musician is ever turned away for lack of funds.',
          'containsHTML': 'false',
        },
      ]
    },
    overview_blocks : [
      {
        title : 'Training Residency',
        description : [
          {
            'text':'The training residency for NYO-China\'s 2018 Chamber Series will take place from July 15 to 28 at the Central Conservatory of Music in Beijing. There, about ten to fifteen exceptional student musicians will have the opportunity to intimately study with the program\'s teaching artists. Besides daily rehearsals in chamber groups, students will attend regular master classes, seminars on theory and improvisation, and one-on-one music lessons.',
            'containsHTML': 'false',
          }
        ]
      },
      {
        title : 'Concert Tour',
        description : [
          {
            'text':'From July 29 to August 4, students will perform alongside their teaching artists in a series of chamber music recitals at premier venues throughout China, beginning with a concert at the Central Conservatory of Music in Beijing. Along the way, they will also perform at the Qingdao International Music Festival and play with students from the National Youth Orchestra of the United States in America (NYO-USA).',
            'containsHTML': 'false',
          }
        ]
      },
    ],
    teaching_artists : {
      title : 'Teaching Artists',
      artists : [
        {
          title : 'Qing Li, Strings',
          description : [
            {
              'text':'Bringing great warmth, poise, and insight to her music making, Qing Li is a versatile artist who serves as the Baltimore Symphony’s Principal Second Violin, as well as a frequent soloist. Li is also a Piatigorsky Foundation Artist, much sought-after recitalist, chamber musician, and guest concertmaster. Notable reviews for Qing Li include The German Hohenlohe News (“excelled with ethereal play”) and the Richmond Times (“her style was impeccable”). Li is currently also a violin faculty member of the Peabody Institute of The Johns Hopkins University. She gives master classes throughout the American, Asian, and South American major conservatories and international festivals. Born in Beijing, China, Li began violin studies at age four with her father. At age 12, Qing Li was accepted to the Central Conservatory of Music in Beijing. Based on a prize-winning Sibelius Violin Concerto performance at the first Beijing International Violin Competition, Berl Senofsky brought her to the Peabody Conservatory where she was granted a full scholarship. She currently performs on her Neopolitain instrument made by Nicolo Gagliano in 1736.',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : 'Yong Ma, Woodwinds',
          description : [
            {
              'text':'Yong Ma is Principal Flute at the China National Opera and has been hailed by the New York Concert Review as a player of “astonishing brilliance” since his debut at Carnegie Hall. Mr. Ma began studying flute at the age of eight in China and later became a student of Yongxin Wang at the Central Conservatory of Music in Beijing, and at thirteen, he was a finalist in the “Prague Spring” International Music Competition. In 1996, Mr. Ma came to the United States and later earned both his Bachelor and Master degrees from the Juilliard School in New York, where he studied with Carol Wincenc and Robert Langevin. Mr. Ma is very active as a soloist, orchestral player, chamber music player and teacher. Before his current role at the China National Opera, he served as Principal Flute in the Shenzhen Symphony Orchestra and the Louisville Orchestra. He has performed with the New York Philharmonic, Baltimore Symphony Orchestra, Malaysian Philharmonic and Juilliard Orchestra. From 2013 he was the flute professor in Shanxi North University of China, China Orchestra Academy at the Central Conservatory of Music and the Art Institute of Jilin. ',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : 'Guang Chen, Brass',
          description : [
            {
              'text':'Guang Chen is a professor at the Central Conservatory of Music in Beijing, the Chief Executive Director of China’s Orchestra Academy, and the Visiting Principal Trumpeter with the China National Symphony Orchestra. He is a former student of Professor Ji Rui-kai and in 1999 he was sponsored by the Zubin Mehta Scholarship to study at the University of Music and Performing Arts, Vienna. From then on, Guang Chen performed with the Vienna State Opera, the Vienna Chamber Orchestra, and the Vienna Strauss Orchestra. Since graduating from Vienna in 2005, Guang Chen has performed as the visiting Principal Trumpeter for multiple world-famous orchestras including the China Philharmonic Orchestra, the National Ballet of China, and many other municipal orchestras. From July 2008 to July 2012, Guang Chen performed in concerts across Asia as the Principal Trumpeter for the Asia Philharmonic Orchestra. In 2011, he was invited by the Malaysian Philharmonic Orchestra to perform as Principal Trumpeter, and he has performed and recorded in the same position for the Singapore Symphony Orchestra.',
              'containsHTML': 'false',
            }
          ]
        },
      ]
    },
    student_artists : {
      title : 'Class of 2018',
      artists: [
        {
          isClickable : false,
          'name' : 'Yubo Cao',
          'position' : 'Violin',
          'affiliation' : 'Central Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Yiqing Fu',
          'position' : 'Violin',
          'affiliation' : 'Peabody Institute of Music',
        },
        {
          isClickable : false,
          'name' : 'Hanke Li',
          'position' : 'Violin',
          'affiliation' : 'Central Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Yixiang Wang',
          'position' : 'Violin',
          'affiliation' : 'Shanghai Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Junyi Li',
          'position' : 'Viola',
          'affiliation' : 'Xinghai Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Yujie Zeng',
          'position' : 'Viola',
          'affiliation' : 'Shanghai Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Zhihong Li',
          'position' : 'Cello',
          'affiliation' : 'Mannes School of Music',
        },
        {
          isClickable : false,
          'name' : 'Tiancheng Zhu',
          'position' : 'Cello',
          'affiliation' : 'Matthew McNair Secondary School',
        },
        {
          isClickable : false,
          'name' : 'Yaxin Dang',
          'position' : 'Flute',
          'affiliation' : 'Oberlin Conservatory of Music',
        },
        {
          isClickable : false,
          'name' : 'Zishu Xie',
          'position' : 'Flute',
          'affiliation' : 'Oberlin Conservatory of Music',
        },
        {
          isClickable : false,
          'name' : 'Ning Zhang',
          'position' : 'Clarinet',
          'affiliation' : 'The Juilliard School',
        },
        {
          isClickable : false,
          'name' : 'Huibin Zou',
          'position' : 'Clarinet',
          'affiliation' : 'Cleveland Institute of Music',
        },
        {
          isClickable : false,
          'name' : 'Jinren Cheng',
          'position' : 'Oboe',
          'affiliation' : 'Central Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Yichuan Wang',
          'position' : 'Oboe',
          'affiliation' : 'Central Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Jingyang Wang',
          'position' : 'Bassoon',
          'affiliation' : 'Central Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Yicheng Gong',
          'position' : 'French Horn',
          'affiliation' : 'Shanghai Conservatory of Music Middle School',
        },
        {
          isClickable : false,
          'name' : 'Jihan Zhang',
          'position' : 'French Horn',
          'affiliation' : 'Shandong Jinan No. 13 Middle School',
        },
        {
          isClickable : false,
          'name' : 'Zhaoting Liu',
          'position' : 'Trumpet',
          'affiliation' : 'Beijing Bayi High School',
        },
        {
          isClickable : false,
          'name' : 'Tianqi Wu',
          'position' : 'Trumpet',
          'affiliation' : 'Sichuan Conservatory of Music',
        },
        {
          isClickable : false,
          'name' : 'Puyuan Chen',
          'position' : 'Trombone',
          'affiliation' : 'Manhattan School of Music',
        },
        {
          isClickable : false,
          'name' : 'Di Zhou',
          'position' : 'Tuba',
          'affiliation' : 'Shenzhen Longhua Middle School',
        },
      ]
    },
    auditions : {
      title: 'Auditions',
      description : [
        {
          'text':'Auditions will be virtual, with candidates submitting their application materials online. All Chinese citizens (including those living in Hong Kong and Macau) who will be between the ages of 14 and 21 during the course of the program will eligible to apply; existing alumni from NYO-China’s 2017 season are also eligible, regardless of age. Because the focus of this year\'s program will be chamber music, we are only accepting applications for the following instruments: violin, viola, cello, flute, clarinet, oboe, bassoon, horn, trumpet, trombone, and tuba.',
          'containsHTML': 'false',
        },
        {
          'text':'Applications should be emailed to <a style="color: \'grey\'" href="mailto:auditions@nyochina.org">auditions@nyochina.org</a> and should include 1) a completed application form, 2) a link to a video of the student performing a 2- to 4-minute portion of a solo piece and 3) links to separate videos of the student performing the requested excerpts. Videos should be hosted on an easily accessible streaming website like Youku or Tencent; if you make your videos password-protected, please be sure to send us these passwords. Additional application materials such as résumés are welcome but not necessary.',
          'containsHTML': 'true',
        },
        {
          'text' : 'Applications must be submitted by Sunday, June 10, 11:59 PM CST, though admissions are conducted on a rolling basis and students are encouraged to apply early. Applications will be reviewed by this season’s Teaching Artists, and all decisions are expected to be released before the end of June.',
          'containsHTML': 'false',
        }
      ],
      application_form : {
        href : "/img/auditions/application_form.pdf",
        text : 'DOWNLOAD APPLICATION FORM'
      },
      excerpts : {
        title : 'Excerpts',
        description : [
          {
            'text' : 'Applicants are required to submit videos of all requested excerpts (see downloadable links below). For each individual excerpt, the video should be uncut, unedited, and showing your face.',
            'containsHTML' : 'false',
          },
        ],
        excerpts : [
          {
            href : "/img/auditions/violin.pdf",
            text : 'VIOLIN'
          },
          {
            href : "/img/auditions/viola.pdf",
            text : 'VIOLA'
          },
          {
            href : "/img/auditions/cello.pdf",
            text : 'CELLO'
          },
          {
            href : "/img/auditions/flute.pdf",
            text : 'FLUTE'
          },
          {
            href : "/img/auditions/clarinet.pdf",
            text : 'CLARINET'
          },
          {
            href : "/img/auditions/oboe.pdf",
            text : 'OBOE'
          },
          {
            href : "/img/auditions/bassoon.pdf",
            text : 'BASSOON'
          },
          {
            href : "/img/auditions/horn.pdf",
            text : 'HORN'
          },
          {
            href : "/img/auditions/trumpet.pdf",
            text : 'TRUMPET'
          },
          {
            href : "/img/auditions/trombone.pdf",
            text : 'TROMBONE'
          },
          {
            href : "/img/auditions/tuba.pdf",
            text : 'TUBA'
          }
        ]
      }
    },
    signup : {
      instruction : 'More details about the faculty, residency, concert tour, and admissions process will be released soon.',
      form : {
        submissionMessage : 'Thank You!',
        title : 'Learn More',
        instruction : 'Sign up to be notified once more information becomes available.',
        firstName : 'First Name',
        lastName : 'Last Name',
        email : 'Email Address',
        submit : 'SIGN UP',
        'missingFirstAndLastNameMsg' : 'Name is required.',
        'missingFirstNameMsg' : 'Name is missing required subfields: First',
        'missingLastNameMsg' : 'Name is missing required subfields: Last',
        'missingEmailMsg' : 'Email Address is required',
        'invalidEmailMsg' : 'Email Address is not valid. Email addresses should follow the format user@domain.com.',
      }
    },
  },
  press_media_page : {
    featured_articles : {
      title : 'Featured Press',
      articles: [
        {
          isLink : true,
          href : 'https://www.nytimes.com/2017/07/18/arts/music/in-these-national-orchestras-of-china-and-united-states-youth-meets-musical-beauty.html',
          imgSrc : '/img/media/articles/youth.png',
          title : 'In These Orchestras, Youth Meets Beauty (July 18, 2017)',
          description : [
            {
              containsHTML : true,
              text : 'By James R. Oestreich, <em> The New York Times </em>',
            }
          ]
        },
        {
          isLink : true,
          href : 'https://www.nytimes.com/2017/07/23/arts/music/review-us-youth-orchestra-inspires-a-chinese-counterpart.html',
          imgSrc : '/img/media/articles/counterpart.png',
          title : 'Review: U.S. Youth Orchestra Inspires a Chinese Counterpart (July 23, 2017)',
          description : [
            {
              containsHTML : true,
              text : 'By Anthony Tommasini, <em> The New York Times </em>',
            }
          ]
        },
        {
          isLink : true,
          href : 'https://www.steinway.com/news/features/china-nyo',
          title : 'Breaking Cultural Barriers, One Score at a Time (July 27, 2017)',
          description : [
            {
              containsHTML : true,
              text : 'By Kelly Kollias, <em> Steinway Magazine </em>',
            }
          ]
        },
        {
          isLink : true,
          href : 'http://usa.chinadaily.com.cn/epaper/2017-07/28/content_30280812.htm',
          title : 'Drills, Thrills for China Youth Orchestra (July 28, 2017)',
          description : [
            {
              containsHTML : true,
              text : 'By Hong Xiao, <em> China Daily </em>',
            }
          ]
        },
        {
          isLink : true,
          href : 'https://www.fromthetop.org/musician/national-youth-orchestra-china/',
          title : 'NPR From the Top: Meet the National Youth Orchestra of China (July 2017)',
          description : []
        },
        {
          isLink : true,
          href : 'https://www.wqxr.org/story/national-youth-orchestra-china/',
          title : 'WQXR Young Artist Showcase: NYO-China (July 2017)',
          description : []
        },
      ]
    },
    journals : {
      title : 'Publications',
      journals : [
        {
          isLink: true,
          href : 'https://issuu.com/nyochina/docs/nyo-china-2017-journal-english',
          src : '/img/2017_journal_en.png',
        },
        {
          isLink: true,
          href : 'https://issuu.com/nyochina/docs/nyo-china-class-of-2017-english',
          src : '/img/2017_class_book_en.png',
        },
        {
          isLink: true,
          href : 'https://issuu.com/nyochina/docs/2018_journal__english_',
          src : '/img/2018_journal.png',
        },
      ],
    },
    support_letters : {
      title : 'Letters of Support',
      letters: [
        {
          imgSrc: '/img/media/letters/cuomo.jpg',
          description: [
            {
              containsHTML: false,
              text : 'Andrew M. Cuomo, Governor of New York',
            }
          ]
        },
        {
          imgSrc: '/img/media/letters/de_blasio.jpg',
          description: [
            {
              containsHTML: false,
              text : 'Bill de Blasio, Mayor of New York City',
            }
          ]
        },
        {
          imgSrc: '/img/media/letters/locke.jpeg',
          description: [
            {
              containsHTML: false,
              text : 'Gary Locke, Former US Ambassador to China, US Secretary of Commerce, and Governor of Washington',
            }
          ]
        },
        {
          imgSrc: '/img/media/letters/qiyue_zhang.jpg',
          description: [
            {
              containsHTML: false,
              text : 'Zhang Qiyue, Ambassador and Consul General of the People\'s Republic of China in New York',
            }
          ]
        }
      ]
    },
    videos : {
      title : 'Films',
      videos : [
        {
          src : "https://player.vimeo.com/video/278051090",
        },
        {
          src : "https://player.vimeo.com/video/278527761",
        },
        {
          src : "https://player.vimeo.com/video/278194654",
        }
      ]
    },
    link_to_videos : {
      text : 'VIEW THE REST OF OUR FILMS HERE',
      href : 'https://vimeo.com/user21234279',
    },
    photo_gallery : {
      title : 'Photo Gallery',
      photos : [
        '/img/media/photos/1.jpg',
        '/img/media/photos/2.jpg',
        '/img/media/photos/3.jpg',
        '/img/media/photos/4.jpg',
        '/img/media/photos/5.jpg',
        '/img/media/photos/6.jpg',
        '/img/media/photos/7.jpg',
        '/img/media/photos/8.jpg',
        '/img/media/photos/9.jpg',
        '/img/media/photos/10.jpg',
        '/img/media/photos/11.jpg',
        '/img/media/photos/12.jpg',
        '/img/media/photos/13.jpg',
        '/img/media/photos/14.jpg',
        '/img/media/photos/15.jpg',
        '/img/media/photos/16.jpg',
        '/img/media/photos/17.jpg',
        '/img/media/photos/18.jpg',
        '/img/media/photos/19.jpg',
        '/img/media/photos/20.jpg',
        '/img/media/photos/21.jpg',
        '/img/media/photos/22.jpg',
        '/img/media/photos/23.jpg',
        '/img/media/photos/24.jpg',
      ],
    }
  },
  'footer' : {
    'copyright' : 'Copyright © 2017 NYO-China. All rights reserved.',
  }

}



// WEBPACK FOOTER //
// ./src/data-en.js